import { END_POINT_JOBS, END_POINT_JOB_DETAIL } from "../api/EndPoint";
import { JWT } from "../utils/CommonConstant";
import { JOB_LIST, JOB_DETAIL, JOB_EDIT, DELETE_JOB_SUCCESS } from "./ActionType";
import { GET_SUCCESS, RESPONSE_CODE_DELETE_SUCCESS, RESPONSE_CODE_UNAUTHORIZED } from "../api/ResponseType";
import axios from "axios";
import sha256 from "crypto-js/sha256";
import moment from 'moment'

export const getJobsList = (page_index) => dispatch => {

  axios({
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      'pragma': 'no-cache',
      'cache-control': 'no-cache',
      Authorization:
        "Bearer " +
        sha256(
          Math.random()
            .toString(36)
            .substring(7)
        )
    },
    withCredentials: false,
    mode: "no-cors",
    url: END_POINT_JOBS,
    params: { 
      page: page_index, sort: "-_created",
      where: '{"close_date": {"$gt": "'+ new Date().toGMTString() + '"}}'
    }
  })
    .then(response => {
    
      if (response.status === GET_SUCCESS) {
        dispatch({
          type: JOB_LIST,
          payload: response.data._items
        });
      } else {
        window.alert("SERVER ERROR FOUND");
      }
    })
    .catch(error => {
      window.alert("NETWORK ERROR "+error);
    });
};

export const getPrevJobsList = (page_index) => dispatch => {

  axios({
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      'pragma': 'no-cache',
      'cache-control': 'no-cache',
      Authorization:
        "Bearer " +
        sha256(
          Math.random()
            .toString(36)
            .substring(7)
        )
    },
    withCredentials: false,
    mode: "no-cors",
    url: END_POINT_JOBS,
    params: { 
      page: page_index, sort: "-_created",
      where: '{"close_date": {"$lt": "'+ new Date().toGMTString() + '"}}'
    }
  })
    .then(response => {
    
      if (response.status === GET_SUCCESS) {
        dispatch({
          type: JOB_LIST,
          payload: response.data._items
        });
      } else {
        window.alert("SERVER ERROR FOUND");
      }
    })
    .catch(error => {
      window.alert("NETWORK ERROR "+error);
    });
};

export const getJobDetail = job_id => dispatch => {
  axios({
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      'pragma': 'no-cache',
      'cache-control': 'no-cache',
      Authorization:
        "Bearer " +
        sha256(
          Math.random()
            .toString(36)
            .substring(7)
        )
    },
    withCredentials: false,
    mode: "no-cors",
    url: `${END_POINT_JOB_DETAIL}${job_id}`
  })
    .then(response => {
      if (response.status === GET_SUCCESS) {

        dispatch({
          type: JOB_DETAIL,
          payload: response.data
        });

      } else {
        window.alert("SERVER ERROR!", response.status);
      }
    })
    .catch(error => {
      window.alert("SYSTEM ERROR!", error);
    });
};

export const editJob = (edit) => dispatch => {
    dispatch({
      type: JOB_EDIT,
      payload: edit
    })
}

export const deleteJob = (props) => dispatch => {

  axios({
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      "Authorization": sessionStorage.getItem(JWT),
      "If-Match": props._etag
    },
    withCredentials: false,
    mode: "no-cors",
    url: `${END_POINT_JOBS}/${props._job_id}`,
  }).then(response => {
     
      if(response.status === RESPONSE_CODE_DELETE_SUCCESS) {

        window.alert("Job Delete Success")

        dispatch({
          type: DELETE_JOB_SUCCESS,
          payload: true
        })

        axios({
          method: "get",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            Authorization:
              "Bearer " +
              sha256(
                Math.random()
                  .toString(36)
                  .substring(7)
              )
          },
          withCredentials: false,
          mode: "no-cors",
          url: END_POINT_JOBS,
          params: { 
            page: props.page_index, sort: "-_created",
            where: '{"close_date": {"$gt": "'+ new Date().toGMTString() + '"}}'
          }
        })
          .then(response => {

            dispatch({
              type: DELETE_JOB_SUCCESS,
              payload: false
            })

            if (response.status === GET_SUCCESS) {
              dispatch({
                type: JOB_LIST,
                payload: response.data._items
              });
            } else {
              window.alert("SERVER ERROR FOUND");
            }
          })
          .catch(error => {
            window.alert("NETWORK ERROR "+error);
          });

      }else{
        window.alert("Job Delete Failed")
      }
     
  }).catch(error => {

      window.alert("Connection Failed!", error)
  })

}

export const doneEdit = (prop, redirectHandler) => dispatch => {
  const{
    _etag,
    _id,
    // active,
    benefits,
    category,
    close_date,
    contract,
    department,
    description,
    entity,
    location,
    requirements,
    salary,
    title,
  } = prop
  // dispatch({
  //       type: JOB_EDIT,
  //       payload: false
  // })

  axios({
    method: "patch",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      "Authorization": sessionStorage.getItem(JWT),
      "If-Match": _etag
    },
    withCredentials: false,
    mode: "no-cors",
    url: `${END_POINT_JOBS}/${_id}`,
    data: {
            title,
            salary,
            requirements,
            location,
            entity,
            description,
            department,
            contract: {
              from: typeof contract.from !== 'string' ? contract.from.format("ddd, DD MMM YYYY HH:mm:ss [GMT]") : contract.from,
              to: typeof contract.to !== 'string' ? contract.to.format("ddd, DD MMM YYYY HH:mm:ss [GMT]") : contract.to,
              type: contract.type
            },
            close_date: typeof close_date === 'string' ? close_date : close_date.format("ddd, DD MMM YYYY HH:mm:ss [GMT]"),
            category,
            benefits
          }
  }).then(response => {

    dispatch({
        type: JOB_EDIT,
        payload: false
    })
    
    if(response.status === GET_SUCCESS){
      window.alert("Job Update Success")
      redirectHandler();
      
    }else {
      window.alert("Job Update Failed")
    }
    
  }).catch(error => {
    window.alert("NETWORK FAILED "+error)
  })

}

export const activeJob = (props) => dispatch => {

  const update_close_date = moment().add(14, 'day').format("ddd, DD MMM YYYY HH:mm:ss [GMT]")

  axios({
    method: "patch",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      "Authorization": sessionStorage.getItem(JWT),
      "If-Match": props.job._etag
    },
    withCredentials: false,
    mode: "no-cors",
    url: `${END_POINT_JOBS}/${props.job._id}`,
    data: {
          close_date: update_close_date 
    }
  }).then(response => {

    if(response.status === GET_SUCCESS){

      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          'pragma': 'no-cache',
          'cache-control': 'no-cache',
          Authorization:
            "Bearer " +
            sha256(
              Math.random()
                .toString(36)
                .substring(7)
            )
        },
        withCredentials: false,
        mode: "no-cors",
        url: END_POINT_JOBS,
        params: { 
          page: props.page_index, sort: "-_created",
          where: '{"close_date": {"$lt": "'+ new Date().toGMTString() + '"}}'
        }
      })
        .then(response => {
        
          if (response.status === GET_SUCCESS) {
            dispatch({
              type: JOB_LIST,
              payload: response.data._items
            });
          } else {
            window.alert("SERVER ERROR FOUND");
          }
        })
        .catch(error => {
          window.alert("NETWORK ERROR "+error);
        });

    }else{
      window.alert("Update failed!")
    }

  }).catch(error => {

    if(error.response.status === RESPONSE_CODE_UNAUTHORIZED) {
      window.alert("Unauthorized! Please login again.", error);
      dispatch({
        type: "job-unauthorize",
        payload: true
      })
    }else{
      window.alert("error: ", error)
    }


  })

}